import { withI18nPlaceholders } from '@change-corgi/core-react/i18n';

import I18N_PLACEHOLDERS from '#config/i18n/placeholders/supporterVoicesVideo/supporter-voices-video.yml';

import { PetitionActions as PetitionActionsBase } from './entryPoint';

// The supporter_voices_video_first ask copy (CHANGE-97687) lives in placeholders rather than
// config/i18n/corgi.en-US.yml because it is experiment copy, and that is where experiment copy
// belongs for as long as the experiment runs. This wrapper stays for the life of the test; it is
// not a temporary measure waiting on a sign-off. See the bundle's own header for the reasoning.
export const PetitionActions = withI18nPlaceholders(I18N_PLACEHOLDERS, PetitionActionsBase);
